import { render, staticRenderFns } from "./usersDialog.vue?vue&type=template&id=1b1be2c0&"
import script from "./usersDialog.vue?vue&type=script&lang=js&"
export * from "./usersDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports